import Header from "../../header/Header";
import Conditions from "../conditions_info/Conditions";
import Footer from "../../footer/Footer";


function ConditionsLanding() {
    return (
        <div className="conditions_landing">
            <Header/>
            <Conditions/>
            <Footer/>
        </div>
    )
}

export default ConditionsLanding